<template>
  <div style="width:260px;min-height:1080px;">
    <v-card class="pa-0 ma-0" style="width:260px;min-height:1079px;" elevation="1">
      <div class="layout-menu menu-vertical menu bg-menu-theme">
        <ul class="menu-inner py-1 ps">
          <div style="width:100%" v-for="(item) in items" :key="item.title" :href="item.href">
            <li class="menu-header small">
              <span class="menu-header-text">{{item.title}}</span>
            </li>
            <li
              v-for="child in item.items"
              :key="child.title"
              :class="[navCode2 == child.nums? 'menu-item active': 'menu-item']"
            >
              <span class="menu-link" @click="goViewPage(child.href)">
                <v-icon :class="[navCode2 == child.nums? 'menu-icon tf-icons bx ic-active': 'menu-icon tf-icons bx']" class="">{{child.icons}}</v-icon>
                <div class>{{child.title}}</div>
              </span>
            </li>
          </div>
        </ul>
      </div>
    </v-card>
  </div>
</template>

<style scoped>
.ic-active {color: #696cff !important;}
.navActive { color: #1976d2; font-weight: 800 !important; }
li { list-style: none; }
.layout-menu-fixed .layout-menu, .layout-menu-fixed-offcanvas .layout-menu { position: fixed; top: 0; bottom: 0; left: 0; margin-right: 0 !important; margin-left: 0 !important; }
.bg-menu-theme { background-color: #fff !important; color: #697a8d; }
.menu-vertical .menu-inner { flex-direction: column; flex: 1 1 auto; }
.menu-item, .menu-header, .menu-divider, .menu-block { flex: 0 0 auto; flex-direction: column; margin: 0; padding: 0; list-style: none; }
.ps { position: relative; overflow: hidden !important; overflow-anchor: none; -ms-overflow-style: none; touch-action: auto; -ms-touch-action: auto; }
.menu-inner { display: flex; align-items: flex-start; justify-content: flex-start; margin: 0; padding: 0; height: 100%; }
.py-1 { padding-top: 0.25rem !important; padding-bottom: 0.25rem !important; }
.bg-menu-theme .menu-inner > .menu-header::before { background-color: transparent; }
.bg-menu-theme .menu-header:before { background-color: #a1acb8 !important; }
.bg-menu-theme .menu-header:before { content: ""; position: absolute; left: 0; top: 1.1875rem; width: 1rem; height: 1px; transition: all 0.3s ease-in-out; }
.bg-menu-theme .menu-header { color: #a1acb8; }
small, .small { font-size: 85%; }
.bg-menu-theme .menu-header { position: relative; }
.menu-vertical .menu-header { margin: 1rem 0 0.5rem 0; padding: 0.625rem 2rem 0.625rem 2rem; }
.menu-vertical, .menu-vertical .menu-block, .menu-vertical .menu-inner > .menu-item, .menu-vertical .menu-inner > .menu-header { width: 16.25rem; }
.bg-menu-theme .menu-inner-shadow { background: linear-gradient( #fff 41%, rgba(255, 255, 255, 0.11) 95%, rgba(255, 255, 255, 0) ); }
.bg-menu-theme .menu-header:before { content: ""; position: absolute; left: 0; top: 1.1875rem; width: 1rem; height: 1px; transition: all 0.3s ease-in-out; }
.menu-item { margin: 0.0925rem 0; align-items: flex-start; justify-content: flex-start; }
.menu-item.active:before { content: ""; position: absolute; right: 0; width: 0.25rem; height: 2.5rem; border-radius: 0.375rem 0 0 0.375rem; }
.menu-item.active:before { background: #696cff; }
.bg-menu-theme .menu-link, .bg-menu-theme .menu-horizontal-prev, .bg-menu-theme .menu-horizontal-next { color: #697a8d; }
.bg-menu-theme .menu-inner .menu-item .menu-link { border-radius: 0.375rem; }
.menu-item.active > .menu-link { color: #696cff; background-color: rgba(105, 108, 255, 0.16) !important; }
.menu-vertical .menu-item.active:not(.open) > .menu-link { font-weight: 600; }
.menu-item .menu-link { margin: 0rem 1rem; letter-spacing: -0.4px; }
.menu-vertical .menu-item .menu-link { font-size: 14px; }
.menu-vertical .menu-item .menu-link, .menu-vertical .menu-block { padding: 0.625rem 1rem; }
.menu-link { position: relative; display: flex; align-items: center; flex: 0 1 auto; margin: 0; cursor: pointer; }
.menu-vertical .menu-icon { width: 1.5rem; }
.menu-icon { flex-grow: 0; flex-shrink: 0; margin-right: 0.5rem; font-size: 1.25rem; }
.bx { vertical-align: middle; font-size: 1.15rem; line-height: 1; font-family: "boxicons" !important; font-style: normal; font-variant: normal; line-height: 1; text-rendering: auto; display: inline-block; text-transform: none; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }
.menu-item .menu-link { background: #fff; }
.menu-item .menu-link:hover { background: rgba(190, 190, 190, 0.15) !important; transition: 0.3s; }
</style>

<script>
export default {
  name: "Nav",
  props: { navCode1: Number, navCode2: Number, loginInfo2: String, NavList: Array},
  created() {
    //console.log(this.navCode1, this.navCode2);
    this.nowSelectedNav = this.navCode1;
    this.setActive();
    this.items = this.NavList;
  },
  data() {
    return {
      items: [
        {
          action: "mdi-atv",
          active: true,
          items: [
            { title: "차량 리스트", nums: 11, href: "/Vehicle" },
            { title: "차량 등록", nums: 12, href: "/VehicleWrite" }
          ],
          title: "차량관리",
          nums: "1"
        },
        {
          action: "mdi-file-document-edit",
          active: false,
          items: [
            { title: "출고차량 리스트", nums: 21, href: "/VehicleRLS" },
            { title: "출고차량 등록", nums: 22, href: "/VehicleRLSWrite" }
          ],
          title: "출고차량관리",
          nums: "2"
        }
      ]
    };
  },
  methods: {
    /*
      setMenuActive(idx) {
        this.nowSelectedNav = idx-1;
      },
      */
    goViewPage(arg) {
      if (arg) {
        this.$router.push(arg).catch(() => {});
      }
    },
    setActive() {
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].active = false;
      }
      this.items[this.nowSelectedNav - 1].active = true;
    }
  }
};
</script>